@use '~/theme/theme' as *;

.categoryColorIndicator {
  border: border(grey-400);
}

.small {
  width: spacing(2);
  height: spacing(2);

  @include border-radius(xs);
}

.medium {
  width: spacing(3);
  height: spacing(3);

  @include border-radius(xs);
}

.large {
  width: spacing(3.5);
  height: spacing(3.5);

  @include border-radius(sm);
}

.extralarge {
  width: spacing(4);
  height: spacing(4);

  @include border-radius(sm);
}
